export default __webpack_public_path__ + "static/media/sanmar10.f881af99.jpg";